export function getModuleNameFromCallStack(): string {
  const stack = new Error().stack;
  if (!stack) return 'unknown';

  const lines = stack.split('\n');

  for (const line of lines) {
    const match = line.match(/\/src\/modules\/([^/]+)\//);
    if (match) {
      return match[1]; // Returns "testaburger", "orders", etc.
    }
  }

  return 'unknown';
}
